/**
 * The default time interval in seconds when using using event mode
 *
 * @public
 */
export const CMCD_DEFAULT_TIME_INTERVAL = 30
